import React, { useState } from 'react';
import { FORENSIC_PLAIN_FALLBACK } from '../config/forensicJargon';
import ForensicJargonText from './ForensicJargonText';

export default function ForensicPlainLanguageBlock({
    plain,
    technical,
    extraTechnical = null,
    className = '',
}) {
    const [open, setOpen] = useState(false);
    const beginner = (plain && String(plain).trim()) || FORENSIC_PLAIN_FALLBACK;
    const technicalText = technical && String(technical).trim() ? String(technical).trim() : '';
    const hasTechnical = Boolean(technicalText) || Boolean(extraTechnical);

    return (
        <div className={`forensic-plain-block ${className}`.trim()}>
            <p className="forensic-plain">{beginner}</p>
            {hasTechnical && (
                <>
                    <button
                        type="button"
                        className="forensic-plain-toggle"
                        aria-expanded={open}
                        onClick={() => setOpen((value) => !value)}
                    >
                        {open ? 'Hide the technical detail' : 'Show the technical detail'}
                    </button>
                    {open && (
                        <div className="forensic-technical">
                            {technicalText && (
                                <p className="forensic-technical__why">
                                    <ForensicJargonText text={technicalText} />
                                </p>
                            )}
                            {extraTechnical}
                        </div>
                    )}
                </>
            )}
        </div>
    );
}
